import script from "./customTimer.vue?vue&type=script&lang=js"
export * from "./customTimer.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__